import {
    Center,
    Stack,
    Title,
    Text,
    ThemeIcon,
    Anchor,
} from '@mantine/core';
import { Icon } from '@iconify/react';
import { Link } from 'react-router-dom';
import RequestPasswordResetForm from 'src/components/auth/RequestPasswordResetForm';

export default function ForgotPassword() {

    return (
        <Center pt={100} p="md">
            <Stack gap="lg" align="center">
                {/* Icon */}
                <ThemeIcon
                    size={60}
                    radius="xl"
                    variant="light"
                    color="blue"
                >
                    <Icon icon="mdi:lock-reset" width={30} height={30} />
                </ThemeIcon>

                {/* Header */}
                <Stack gap="xs" align="center">
                    <Title order={2}>Forgot Password?</Title>
                    <Text c="dimmed" size="sm" ta="center" maw={350}>
                        No worries! Enter your email address and we'll send you
                        a link to reset your password.
                    </Text>
                </Stack>

                {/* Form */}
                <RequestPasswordResetForm />

                {/* Footer Links */}
                <Anchor component={Link} to="/sign-in" size="sm">
                    <Icon icon="mdi:arrow-left" width={14} style={{ verticalAlign: 'middle', marginRight: 4 }} />
                    Back to Sign In
                </Anchor>
            </Stack>
        </Center>
    );
}
